const HomeTranslationEn = {
    legal_terms: 'Legal terms',
    privacy_policy: 'Privacy policy',
    terms_of_service: 'Terms of service',
    contact: 'Contact',
};

export default HomeTranslationEn;